<div id="map" class="w-full h-96 bg-gray-100 flex items-center justify-center">
  @if (!mapLoaded()) {
    <div class="text-center">
      <div class="spinner border-4 border-gray-300 border-t-secondary rounded-full w-12 h-12 animate-spin mx-auto mb-4"></div>
      <p class="text-gray-600">Chargement de la carte...</p>
    </div>
  }
</div>
